/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactMount = require('./ReactMount');

module.exports = ReactMount.renderSubtreeIntoContainer;


//////////////////
// WEBPACK FOOTER
// ../~/react-dom/lib/renderSubtreeIntoContainer.js
// module id = ../node_modules/react-dom/lib/renderSubtreeIntoContainer.js
// module chunks = 1